
import { call, put, takeEvery } from "redux-saga/effects";
import { actions } from "../../actions/actionsWrapper";
import { eDotDanhGiaLopActionTypeIds, IDotDanhGiaLopActionType, IDotDanhGiaLopActionTypeBase } from "../../action-types/danh-gia/IDotDanhGiaLopActionType";
import { dotDanhGiaLopApi } from "../../../api/danh-gia/dotDanhGiaLopApi";
import { IBaseResponeModel } from "../../../models/response/base-response";
import { IDotDanhGiaLop } from "../../../models/response/danh-gia/IDotDanhGiaLop";
import { IIdsRequest } from "../../../models/request/base/IIdsRequest";
const mainAction = actions.danhGia.dotDanhGiaLopActions;
export function* dotDanhGiaLopSaga(): any {
    yield takeEvery(eDotDanhGiaLopActionTypeIds.LOAD_START, loadWorker)
    yield takeEvery(eDotDanhGiaLopActionTypeIds.ADD_LOP_START, addLopWorker)
    yield takeEvery(eDotDanhGiaLopActionTypeIds.UPDATE_LOP_START, updateLopWorker)
    yield takeEvery(eDotDanhGiaLopActionTypeIds.DELETE_LOP_START, deleteLopWorker)
    // yield takeEvery(eDotDanhGiaActionTypeIds.DELETE_START, deleteWorker)
}

function* loadWorker(action: IDotDanhGiaLopActionType): any {
    const payload = action.payload as IDotDanhGiaLopActionTypeBase<undefined>
    const dotDanhGiaId = payload.dotDanhGiaId;
    const res: IBaseResponeModel = yield call(dotDanhGiaLopApi.SelectByDot, payload.dotDanhGiaId)
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS({
            dotDanhGiaId,
            data: res.data
        }))
    } else {
        yield put(mainAction.LOAD_ERROR({
            dotDanhGiaId,
            data: res.message ?? "Có lỗi"
        }))
    }
}

function* addLopWorker(action: IDotDanhGiaLopActionType): any {
    const payload = action.payload as IDotDanhGiaLopActionTypeBase<IDotDanhGiaLop[]>
    const dotDanhGiaId = payload.dotDanhGiaId;
    const res: IBaseResponeModel = yield call(dotDanhGiaLopApi.Inserts, payload.dotDanhGiaId, payload.data)
    if (res.is_success) {
        yield put(mainAction.ADD_LOP_SUCCESS({
            dotDanhGiaId,
            data: res.data
        }))
    } else {
        yield put(mainAction.ADD_LOP_ERROR({
            dotDanhGiaId,
            data: res.message ?? "Có lỗi"
        }))
    }
}

function* updateLopWorker(action: IDotDanhGiaLopActionType): any {
    const payload = action.payload as IDotDanhGiaLopActionTypeBase<IDotDanhGiaLop[]>
    const dotDanhGiaId = payload.dotDanhGiaId;
    const res: IBaseResponeModel = yield call(dotDanhGiaLopApi.Updates, payload.dotDanhGiaId, payload.data)
    if (res.is_success) {
        yield put(mainAction.UPDATE_LOP_SUCCESS({
            dotDanhGiaId,
            data: res.data
        }))
    } else {
        yield put(mainAction.UPDATE_LOP_ERROR({
            dotDanhGiaId,
            data: res.message ?? "Có lỗi"
        }))
    }
}

function* deleteLopWorker(action: IDotDanhGiaLopActionType): any {
    const payload = action.payload as IDotDanhGiaLopActionTypeBase<IIdsRequest>
    const dotDanhGiaId = payload.dotDanhGiaId;
    const res: IBaseResponeModel = yield call(dotDanhGiaLopApi.Deletes, payload.dotDanhGiaId, payload.data)
    if (res.is_success) {
        yield put(mainAction.DELETE_LOP_SUCCESS({
            dotDanhGiaId,
            data: res.data
        }))
    } else {
        yield put(mainAction.DELETE_LOP_ERROR({
            dotDanhGiaId,
            data: res.message ?? "Có lỗi"
        }))
    }
}
